﻿
import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'time-picker',
    templateUrl: 'timepicker.tmpl.html'
})

export class TimePickerComponent {
    constructor() { } 

    minutes: any[];

    hours: any[];

    @Input()
    hour: number;

    @Output()
    hourChange:EventEmitter<number> = new EventEmitter();

    @Input()
    minute: number;

    @Output()
    minuteChange: EventEmitter<number> = new EventEmitter();

    @Input()
    ampm: string;

    @Output()
    ampmChange: EventEmitter<string> = new EventEmitter();

    ngOnInit() {        
        this.minutes = Array.from(Array(60), (x, i) => i);
        this.hours = Array.from(Array(11), (x, i) => i+1);
    }
    

    hourChanged($event): void {
        this.hour = parseInt($event.target.value);
        this.hourChange.emit(this.hour);
    }

    minuteChanged($event): void {
        this.minute = parseInt($event.target.value);
        this.minuteChange.emit(this.minute);
    }

    ampmChanged($event): void {
        this.ampm = $event.target.value;
        this.ampmChange.emit($event.target.value);
    }
}